//load modules
import Navigation from './components/Navigation';
import Carousel from './components/Carousel';
import Parallax from './components/Parallax';

//components
export const components = {
    'body': Navigation,
    '.header__banner': Carousel,
    '.cta-content': Parallax
};


// WEBPACK FOOTER //
// ./src/js/components.js